/**
 * Analytics Vue Plugin
 * Installs analytics tracking into Vue application
 * Works with Vue 2 and Vue 3
 */

import {
  bootstrap_analytics,
  track_event,
  track_support_search,
  track_category_click,
  track_product_click,
  track_file_download,
  track_menu_click,
  track_cta_click,
  track_hyperlink_click,
  track_product_tab_click,
  track_filter_click,
  track_slider_click,
  track_breadcrumb_click,
  track_homepage_view,
  update_page_context,
  get_page_context,
  detect_device_type,
  ANALYTICS_CONFIG
} from '../analytics/index.js';

/**
 * Analytics Plugin
 * Install with: Vue.use(AnalyticsPlugin, options)
 */
const AnalyticsPlugin = {
  install(Vue, options = {}) {
    // Perform initial bootstrap
    const initial_route = options.initial_route || {};
    const site_overrides = options.site_context || {};

    bootstrap_analytics(initial_route, site_overrides);

    // Create analytics instance
    const analytics_instance = {
      // Core tracking methods
      trackEvent: track_event,
      trackSearch: track_support_search,
      trackCategoryClick: track_category_click,
      trackProductClick: track_product_click,
      trackDownload: track_file_download,
      trackMenuClick: track_menu_click,
      trackCTA: track_cta_click,
      trackLink: track_hyperlink_click,
      trackProductTab: track_product_tab_click,
      trackFilter: track_filter_click,
      trackSlider: track_slider_click,
      trackBreadcrumb: track_breadcrumb_click,
      trackHomepageView: track_homepage_view,

      // Utility methods
      updatePageContext: update_page_context,
      getPageContext: get_page_context,
      getDeviceType: detect_device_type,

      // Config access
      config: ANALYTICS_CONFIG
    };

    // Attach to Vue prototype for Vue 2
    if (Vue.prototype) {
      Vue.prototype.$analytics = analytics_instance;
    }

    // Global property for Vue 3
    if (Vue.config && Vue.config.globalProperties) {
      Vue.config.globalProperties.$analytics = analytics_instance;
    }

    // Also make available via provide/inject for composition API
    if (Vue.provide) {
      Vue.provide('analytics', analytics_instance);
    }

    if (ANALYTICS_CONFIG.debug) {
      console.log('[Analytics Plugin] Installed successfully');
      console.log('[Analytics] Config:', ANALYTICS_CONFIG);
    }
  }
};

export default AnalyticsPlugin;
